/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type JiraFavouriteFilter,
	type StarredMenuQuery,
} from './__generated__/StarredMenuQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	filter: JiraFavouriteFilter;
	count: number;
};

type PreloadedQueries = {
	starredMenuData: StarredMenuQuery;
};

type SidebarStarredMenuEntryPointComponent = EntryPointComponent<PreloadedQueries, {}, {}, {}>;

export const sidebarStarredMenuEntryPoint: EntryPoint<
	SidebarStarredMenuEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<SidebarStarredMenuEntryPointComponent>(
		/* webpackChunkName: "async-nav4-sidebar-starred-menu" */ './StarredMenu.tsx',
	),
	getPreloadProps: ({ cloudId, filter, count }: EntryPointParams) => ({
		queries: {
			starredMenuData: {
				parameters,
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				variables: {
					cloudId,
					count,
					filter,
				},
			},
		},
	}),
});
